const $ = jQuery.noConflict();
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import Moment from 'moment';

import Player from '@vimeo/player';

const tripSlider = $('.hero-trip-finder__slider');
const tripCounter = $('.hero-trip-finder__count.start');

const tripDate = document.querySelector('.form-field-with-label--date-data');

const setInitialSliderButtonDelay = () => {
	if (tripSlider) {
		const sliderDelay = tripSlider.data('slider-delay');
		document.body.style.setProperty('--slider-delay', `${sliderDelay}ms`);
	}
}

const tripCounts = () => {
	if (tripCounter && tripSlider) {
		tripSlider.on(
			'init reInit beforeChange',
			function (event, slick, currentSlide, nextSlide) {
				//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based).
				const i = (nextSlide ? nextSlide : 0) + 1;
				tripCounter.text('0' + i);
				const sliderDelay = slideDurationData[nextSlide];
				document.body.style.setProperty(
					'--slider-delay',
					`${sliderDelay}ms`
				);
				if (Number(slideDurationData[nextSlide]) > Number(slideDurationMinData)) {
					slick.slickPause();
					setTimeout(() => {
						slick.slickPlay();
					},
					Number(slideDurationData[nextSlide]) - Number(slideDurationMinData));
				}
			}
		);
	}
};

const tripDates = () => {
	if (tripDate) {
		const numberOfMonths = 1;
		ReactDOM.render(
			<TripDatePicker numberOfMonths={numberOfMonths} />,
			tripDate
		);
	}
};

class TripDatePicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			startDate: null,
			endDate: null,
			focusedInput: null,
		};
	}

	clearFilter() {
		this.setState({startDate: null, endDate: null, focusedInput: 'startDate'});
	}

	render() {
		return (
			<div className="tf-datepicker">

				<div className="tf-mobile-button-content">
					<div className="tf-mobile-title">
						<button className="tf-close"></button>
						<span className="tf-label">Dates</span>
						<button className="tf-close-all"></button>
					</div>

					<div className="tf-mobile-main">
						<DateRangePicker
							startDate={this.state.startDate}
							startDateId="departure_start"
							endDate={this.state.endDate}
							endDateId="departure_end"
							onDatesChange={({ startDate, endDate }) =>
								this.setState({ startDate, endDate })
							}
							focusedInput={this.state.focusedInput}
							onFocusChange={(focusedInput) =>
								this.setState({ focusedInput })
							}
							showClearDates={false}
							minDate={Moment()}
							hideKeyboardShortcutsPanel={true}
							numberOfMonths={this.props.numberOfMonths}
							renderCalendarInfo={() => (
								<div className="tf-datepicker__bottom">
									<span
										className="tf-datepicker__clear c-btn c-btn--tertiary"
										onClick={this.clearFilter.bind(this)}
									>
										Clear
									</span>
								</div>
							)}
						/>
					</div>

					<button className="tf-apply-filters">Apply Filters</button>
				</div>
			</div>
		);
	}
}

const heroBlocks = [];
const videos = document.querySelectorAll(
	'.hero-trip-finder [data-vimeo-url], .hero-trip__bg [data-vimeo-url]'
);

const vimeoPlayer = () => {
	if (videos.length) {
		videos.forEach((video) => {
			const parentBlock = video.closest('.block-hero-homepage, .hero-trip__bg');
			if (parentBlock) {
				heroBlocks.push(video.closest('.block-hero-homepage, .hero-trip__bg'));
			}
			const player = new Player(video);
			player.setQuality('720p');
			player.on('play', function () {
				player.element.parentElement.classList.add('loaded');
			});
			Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(
				function (dimensions) {
					parentBlock.style.setProperty(
						'--videoRatio',
						`${dimensions[0] / dimensions[1]}`
					);
				}
			);
		});
	}
};

const setVideoSize = () => {
	if (heroBlocks.length) {
		heroBlocks.forEach((heroBlock) => {
			heroBlock.style.setProperty(
				'--blockHeight',
				`${heroBlock.offsetHeight / 16}rem`
			);
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		setInitialSliderButtonDelay();
		tripDates();
		vimeoPlayer();
		setVideoSize();
	},
	loaded() {
		tripCounts();
	},
	resized() {
		setVideoSize();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
